import React, { useEffect } from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import '@style/counter.css';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { addCommas, removeNonNumeric } from '@helper';
import { Counter } from '@components';

const IsStock = ({ stockRate, repaymentQtyAmount }) => {
    const {
        PayOffStore: { getStockQry, stockList, setCount, updateData },
        AuthStore: { borrowingAmount },
    } = useStore();
    useEffect(() => {
        getStockQry();
    }, []);

    return (
        <div id="stock-payoff">
            <p className="title mt-sm-0 mt-3 d-sm-none text-end">
                前一營業日報價資訊
            </p>
            {stockList.map(
                (
                    {
                        stockNo,
                        stockName,
                        qty,
                        closePrice,
                        marketVal,
                        repaymentQty,
                    },
                    index
                ) => {
                    return (
                        <ul
                            className="stock-list d-sm-none"
                            key={`userstock_${index}`}
                        >
                            <li className="d-flex flex-wrap py-2 px-3 mb-3">
                                <div className="stock-choose d-flex  mb-2">
                                    <div className="stock-name text-black2 col-8">
                                        <span className="me-2">{stockNo}</span>
                                        {stockName}
                                    </div>
                                    {!!qty && (
                                        <Counter
                                            value={repaymentQty}
                                            stockAmount={qty}
                                            increase={() => {
                                                setCount({
                                                    index,
                                                    value: repaymentQty + 1,
                                                });
                                            }}
                                            decrease={() => {
                                                setCount({
                                                    index,
                                                    value: repaymentQty - 1,
                                                });
                                            }}
                                            onChange={e => {
                                                setCount({
                                                    index,
                                                    value: e.target.value,
                                                });
                                            }}
                                        />
                                    )}
                                </div>
                                <div className=" d-flex align-items-baseline">
                                    <div className="stock-number d-flex me-2 align-items-baseline">
                                        <small className="gray-light me-1">
                                            張數
                                        </small>
                                        <span className="text-black2">
                                            {qty}
                                        </span>
                                    </div>
                                    <div className="stock-number d-flex me-2 align-items-baseline">
                                        <small className="gray-light me-1">
                                            收盤
                                        </small>
                                        <span className="pricee text-black2">
                                            <span>$</span>
                                            {closePrice}
                                        </span>
                                    </div>
                                    <div className="stock-number d-flex align-items-baseline">
                                        <small className="gray-light me-1">
                                            市價
                                        </small>
                                        <span className="pricee text-black2">
                                            <span>$</span>
                                            {addCommas(
                                                removeNonNumeric(
                                                    Math.round(
                                                        marketVal * 100
                                                    ) / 100
                                                )
                                            )}
                                        </span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    );
                }
            )}
            <div className="desk-show table-freezes overflow-auto mt-3">
                <table cellSpacing={0} className="table table_sty mb-1">
                    <thead>
                        <tr>
                            <th width="15%">股票代號</th>
                            <th width="16%">股票名稱</th>
                            <th width="16%">擔保品張數</th>
                            <th width="16%">
                                <div className=" h-r">
                                    收盤價
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>前一營業日收盤價</Tooltip>
                                        }
                                    >
                                        <i className="d-none d-sm-inline icon_point bi-exclamation-circle" />
                                    </OverlayTrigger>
                                </div>
                            </th>
                            <th width="15%">
                                <div className=" h-r2">
                                    市值
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>前一營業日市值</Tooltip>
                                        }
                                    >
                                        <i className="d-none d-sm-inline icon_point bi-exclamation-circle" />
                                    </OverlayTrigger>
                                </div>
                            </th>
                            <th width="22%">賣股還款張數</th>
                        </tr>
                    </thead>
                    <tbody>
                        {stockList.map(
                            (
                                {
                                    stockNo,
                                    stockName,
                                    qty,
                                    closePrice,
                                    marketVal,
                                    repaymentQty,
                                },
                                index
                            ) => {
                                return (
                                    <tr key={`userstock_${index}`}>
                                        <th>
                                            <span className="co-name">
                                                {stockNo}
                                            </span>
                                        </th>
                                        <td>{stockName}</td>
                                        <td>
                                            <div className="num_qut t-r3">
                                                {qty}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="num_price t-r">
                                                <span>$</span>
                                                {closePrice}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="num_price t-r2">
                                                <span>$</span>
                                                {addCommas(
                                                    removeNonNumeric(
                                                        Math.round(
                                                            marketVal * 100
                                                        ) / 100
                                                    )
                                                )}
                                            </div>
                                        </td>
                                        {!!qty && (
                                            <td>
                                                <Counter
                                                    value={repaymentQty}
                                                    stockAmount={qty}
                                                    increase={() => {
                                                        setCount({
                                                            index,
                                                            value:
                                                                repaymentQty +
                                                                1,
                                                        });
                                                    }}
                                                    decrease={() => {
                                                        setCount({
                                                            index,
                                                            value:
                                                                repaymentQty -
                                                                1,
                                                        });
                                                    }}
                                                />
                                            </td>
                                        )}
                                    </tr>
                                );
                            }
                        )}
                    </tbody>
                </table>
            </div>
            <div className="totalbox text-end py-3">
                <p className="price">
                    <label className="text-black2 align-text-bottom fw-bolder">
                        賣出以上擔保品，試算維持率為
                    </label>
                    {stockList.every(stock => !parseInt(stock.repaymentQty)) ? (
                        <b className="text-danger ps-3">尚未輸入張數</b>
                    ) : (
                        <b className="text-orange fit-3 ps-3">
                            {stockRate <= 0 ||
                            repaymentQtyAmount >= borrowingAmount
                                ? 0
                                : Math.floor(stockRate * 100) / 100}
                            <span>%</span>
                        </b>
                    )}
                </p>
            </div>
            <div className="btn_box d-flex  flex-column-reverse flex-sm-row justify-content-center">
                <button
                    className="btn_cancel m-border-0 btn rounded-pill text-end text-sm-center"
                    type="button"
                    onClick={() => {
                        updateData(
                            'stockList',
                            stockList.map(item => ({
                                ...item,
                                repaymentQty: 0,
                            }))
                        );
                    }}
                >
                    清 除
                </button>
                {stockList.every(stock => !parseInt(stock.repaymentQty)) ? (
                    <button
                        className="btn_check btn rounded-pill text-white"
                        disabled
                    >
                        申 請
                    </button>
                ) : (
                    <button
                        className="btn_check btn rounded-pill text-white"
                        type="submit"
                    >
                        申 請
                    </button>
                )}
            </div>
        </div>
    );
};

export default observer(IsStock);
